import { ref, computed } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { SplitEditorModel } from '../models/split-editor-model';
import { useDisposes } from '@telecom/shared/composables/use-disposes';
import type { Paragraph } from '../../paragraph-editor/type';

export const useSplitEditorState = createSharedComposable(<T extends Paragraph = Paragraph>() => {
    const splitEditorModel = injectService<SplitEditorModel>(SplitEditorModel);

    const splitEditorState = ref(splitEditorModel.modelData);

    const { disposes } = useDisposes();

    disposes.push(
        splitEditorModel.onStatesChange(state => splitEditorState.value = state),
    );

    const editingParagraph = computed({
        get: () => splitEditorState.value.editingParagraph as T,
        set: (value) => splitEditorModel.update(state => ({ ...state, editingParagraph: value })),
    });

    return {
        editingParagraph,
        splitEditorState,
    };
});
